import React, { useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { TextField, MenuItem } from '@mui/material';

const Step1 = ({ formData, setFormData, errors, setErrors }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleDateChange = (date) => {
    setFormData((prev) => ({ ...prev, productRiskDate: date }));
    if (errors.productRiskDate) {
      setErrors((prev) => ({ ...prev, productRiskDate: '' }));
    }
  };

  return (
    <>
      <span className='top-text'>
        პროდუქტთან დაკავშირებული ინციდენტი/საფრთხე უნდა აღიწეროს დეტალურად.
        მიღებული ინფორმაცია გამოყენებული იქნება მომხდარი ფაქტის გამოსაკვლევად.
        იმ შემთხვევაში, თუ საჭირო გახდა დამატებითი დეტალების დაზუსტება, მოხდება
        თქვენთან დაკავშირება.
      </span>
      <div className='step-container'>
        <div className='step-text'>
          <span className='step-number'>1. </span>რა საფრთხეს შეიცავს პროდუქტი?
        </div>
        <div className='step-details'>
          <p>აღწერისას უნდა გაითვალისწინოთ შემდეგი დეტალები:</p>
          <ul>
            <li>რა მოხდა რამაც განცხადების გაკეთება გადაგაწყვეტინათ?</li>
            <li>რა ტიპის პროდუქტი იქნა გამოყენებული?</li>
            <li>ვინ იყენებდა პროდუქტს?</li>
            <li>როგორ იქნა პროდუქტი გამოყენებული?</li>
            <li>
              გამოიწვია თუ არა რაიმე სახის დაზიანება პროდუქტმა მისი
              გამოყენებისას, ან იყო თუ არა ამისი საშიშროება?
            </li>
            <li>როგორ გამოიწვია პროდუქტმა დაზიანება?</li>
          </ul>
        </div>
      </div>
      <span className='problem-desc-head'>
        პერსონალური ინფორმაცია...(სავალდებულო)*
      </span>
      <TextField
        select
        fullWidth
        className='mb-20-mt-10'
        label='მომხმარებლის ტიპი'
        name='userType'
        value={formData.userType}
        onChange={handleChange}
        error={!!errors.userType}
        helperText={errors.userType}
      >
        <MenuItem value='მომხმარებელი'>მომხმარებელი</MenuItem>
        <MenuItem value='პროფესიონალი'>პროფესიონალი</MenuItem>
      </TextField>

      <div className='problem-desc'>
        <span className='problem-desc-head'>
          პერსონალური ინფორმაცია...(სავალდებულო)*
        </span>
        <TextField
          fullWidth
          multiline
          rows={4}
          className='mb-20-mt-10'
          label='აღწერეთ რა მოხდა...'
          name='incidentDescription'
          value={formData.incidentDescription}
          onChange={handleChange}
          error={!!errors.incidentDescription}
          helperText={errors.incidentDescription}
        />
      </div>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          label='როდის დააფიქსირეთ პროდუქტის საფრთხე'
          inputFormat='DD/MM/YYYY'
          className='mb-20-mt-10 prct-55'
          value={formData.productRiskDate}
          onChange={handleDateChange}
          renderInput={(params) => (
            <TextField
              fullWidth
              {...params}
              error={!!errors.productRiskDate}
              helperText={errors.productRiskDate}
            />
          )}
        />
      </LocalizationProvider>
    </>
  );
};

export default Step1;
